import { DateTime } from "luxon";

import { WorkingCondition } from "../../types/WorkingCondition";

export class DiggingLocationDTO {
  diggingPatternId: number
  pit: string
  pitId: number
  patternBlast: string
  patternBlastId: number
  blastMasterId: number
  pitStage: string
  pitStageId: number
  startTime: DateTime
  workingCondition: WorkingCondition
  rowVersion?: string
  constructor(
    data: {
      diggingPatternId: number
      pit: string
      pitId: number
      patternBlast: string
      patternBlastId: number
      blastMasterId: number
      pitStage: string
      pitStageId: number
      startTime: DateTime
      workingCondition: WorkingCondition
      rowVersion?: string
    }
  ) {
    this.diggingPatternId = data.diggingPatternId
    this.pit = data.pit
    this.pitId = data.pitId
    this.patternBlast = data.patternBlast
    this.patternBlastId = data.patternBlastId
    this.blastMasterId = data.blastMasterId
    this.pitStage = data.pitStage
    this.pitStageId = data.pitStageId
    this.startTime = data.startTime
    this.workingCondition = data.workingCondition
    this.rowVersion = data.rowVersion
  }
}
